export const CALCULATION_VERSION = 'someac-calc-v1';
export const coverage = (expectedSeconds = 0, coveredSeconds = 0) => {
  const expected = Math.max(expectedSeconds, 0);
  const covered = Math.min(Math.max(coveredSeconds, 0), expected);
  return { expectedSeconds: expected, coveredSeconds: covered, missingSeconds: expected - covered,
    coveragePct: expected > 0 ? covered * 100 / expected : null };
};

export function withLineage(measure, context = {}) {
  return { ...measure, value: measure?.value ?? null, unit: measure?.unit || null,
    status: measure?.status || (measure?.value != null ? 'complete' : 'unavailable'), reasonCodes: measure?.reasonCodes || [],
    sourceKind: measure?.sourceKind || context.sourceKind || 'calculated',
    calculationVersion: CALCULATION_VERSION,
    configurationVersion: context.configurationVersion ?? null,
    profileId: context.profileId ?? null, profileVersion: context.profileVersion ?? null,
    cutoffTime: measure?.cutoffTime ?? context.cutoffTime ?? null, watermarkCommitSeq: context.confirmedCommitSeq ?? '0',
    sourceWatermark: measure?.sourceWatermark ?? context.sourceWatermark ?? null,
    coverage: measure?.coverage || context.coverage || coverage() };
}

export function annotateMeasures(value, context) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  const children = Object.fromEntries(Object.entries(value).map(([key, child]) => [key,
    child && typeof child === 'object' && !Array.isArray(child) ? annotateMeasures(child, context) : child]));
  return Object.prototype.hasOwnProperty.call(value, 'value') && value.unit
    ? withLineage(children, context) : children;
}
